import { VerificationStatus } from "@wingspanhq/payments/dist/interfaces";
import { useFeatureFlags } from "../../query/hooks/useFeatureFlags";
import { usePaymentsStatusQuery } from "../../query/payments/queries";

export function useShouldPauseAccount() {
  const queryFeatureFlags = useFeatureFlags();
  const queryPaymentsSettings = usePaymentsStatusQuery();

  const featureFlags = queryFeatureFlags.data;
  const paymentsSettings = queryPaymentsSettings.data;

  return (
    featureFlags?.accountPause &&
    paymentsSettings?.verifications.banking !== VerificationStatus.Verified
  );
}
